"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _object = require("lodash/object");

var _getIndexExchangeTag = _interopRequireDefault(require("./getIndexExchangeTag"));

var _Bidder = _interopRequireDefault(require("../../utils/Bidder"));

var _BidResponse = _interopRequireDefault(require("../../utils/BidResponse"));

var _getGoogleTag = _interopRequireDefault(require("../../google/getGoogleTag"));

var _logger = _interopRequireDefault(require("../../utils/logger"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var indexExchangeBidderName = 'indexExchange'; // Stored for use in `setTargeting`.

var ixRawBidResponses;
var tabConfig;
var leaderboardIXSlotID = 'd-1-728x90-atf-bottom-leaderboard';
var rectangleAdPrimaryIXSlotID = 'd-3-300x250-atf-bottom-right_rectangle';
var rectangleAdSecondaryIXSlotID = 'd-2-300x250-atf-middle-right_rectangle'; // GAMSlotId is the Google ad unit ID.

var mapGAMSlotToIXSlot = function mapGAMSlotToIXSlot(GAMSlotId) {
  var _map;

  var _tabConfig$newTabAds = tabConfig.newTabAds,
      leaderboard = _tabConfig$newTabAds.leaderboard,
      rectangleAdPrimary = _tabConfig$newTabAds.rectangleAdPrimary,
      rectangleAdSecondary = _tabConfig$newTabAds.rectangleAdSecondary; // Key = the GAM ad unit; value = the Index Exchange ID

  var map = (_map = {}, (0, _defineProperty2.default)(_map, leaderboard.adUnitId, leaderboardIXSlotID), (0, _defineProperty2.default)(_map, rectangleAdPrimary.adUnitId, rectangleAdPrimaryIXSlotID), (0, _defineProperty2.default)(_map, rectangleAdSecondary.adUnitId, rectangleAdSecondaryIXSlotID), _map);
  return map[GAMSlotId];
}; // IXSlotId is the Index Exchange slot ID.


var mapIXSlotToAdId = function mapIXSlotToAdId(IXSlotId) {
  var _map2;

  var _tabConfig$newTabAds2 = tabConfig.newTabAds,
      leaderboard = _tabConfig$newTabAds2.leaderboard,
      rectangleAdPrimary = _tabConfig$newTabAds2.rectangleAdPrimary,
      rectangleAdSecondary = _tabConfig$newTabAds2.rectangleAdSecondary; // Key = the Index Exchange ID; value = the GAM ad ID

  var map = (_map2 = {}, (0, _defineProperty2.default)(_map2, leaderboardIXSlotID, leaderboard.adId), (0, _defineProperty2.default)(_map2, rectangleAdPrimaryIXSlotID, rectangleAdPrimary.adId), (0, _defineProperty2.default)(_map2, rectangleAdSecondaryIXSlotID, rectangleAdSecondary.adId), _map2);
  return map[IXSlotId];
};
/**
 * Given IX bid responses, return an object with keys set to adIds
 * and values set to an array of BidResponses for that adId.
 * @param {Array} rawBidData - IX's bid response
 * @return {Object} bidResponses - An object with keys equal to each adId
 *   for which there's a bid and values with an array of BidResponses, the
 *   bidder's normalized bids for that ad.
 */


var normalizeBidResponses = function normalizeBidResponses() {
  var rawBidData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var normalizeBid = function normalizeBid(adId, rawBid) {
    return (0, _BidResponse.default)({
      adId: adId,
      // Index Exchange’s returned "price" field is a CPM in cents, so
      // 265 = $2.65 CPM. Convert to impression revenue.
      revenue: rawBid.price / 10e4,
      advertiserName: indexExchangeBidderName,
      adSize: "".concat(rawBid.size[0], "x").concat(rawBid.size[1])
    });
  };

  var IXBidsBySlot = (0, _object.get)(rawBidData, 'slot', {});
  var normalizedBids = Object.keys(IXBidsBySlot).reduce(function (accumulator, IXSlotId) {
    var IXBidsForThisSlot = (0, _object.get)(IXBidsBySlot, IXSlotId, []);
    var adId = mapIXSlotToAdId(IXSlotId); // This will happen if IX returns some unexpected slot ID.

    if (!adId) {
      return accumulator;
    }

    return _objectSpread(_objectSpread({}, accumulator), {}, (0, _defineProperty2.default)({}, adId, IXBidsForThisSlot.map(function (IXBid) {
      return normalizeBid(adId, IXBid);
    })));
  }, {});
  return normalizedBids;
}; // Index Exchange sometimes calls the retrieveDemand more than once.
// Keep track of requests so we only handle the first one. Note that
// we'll have to refactor this if we ever call for bids more than once
// per page load.


var bidsReturned = false;
/**
 * Return a promise that resolves when the Index Exchange bid
 * responses return or the request times out. See:
 * https://kb.indexexchange.com/Wrapper/Installation/Universal_Library_Implementation.htm
 * @return {Promise<undefined>} Resolves when the bid requests return
 *   or time out.
 */

var fetchBids =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(config) {
    var ixTag, adUnits, IXSlots;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            bidsReturned = false; // Note: use ixTag.cmd.push because the JS may not have
            // loaded. Index Exchange hasn't documented the cmd
            // behavior so it may break.

            ixTag = (0, _getIndexExchangeTag.default)();
            tabConfig = config;
            adUnits = config.adUnits;

            if (adUnits.length) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", Promise.resolve({
              bidResponses: {},
              rawBidResponses: {}
            }));

          case 6:
            IXSlots = adUnits.map(function (adUnit) {
              return {
                htSlotName: mapGAMSlotToIXSlot(adUnit.adUnitId)
              };
            });
            return _context.abrupt("return", new Promise(function (resolve) {
              var timeoutId;

              function handleAuctionEnd(rawBidResponses) {
                _logger.default.debug("IndexExchange: auction ended");

                if (timeoutId) {
                  clearTimeout(timeoutId);
                }

                resolve({
                  bidResponses: normalizeBidResponses(rawBidResponses),
                  rawBidResponses: rawBidResponses
                });
              } // Note that Index Exchange hasn't documented the cmd
              // behavior so it may break.


              ixTag.cmd.push(function () {
                // IX appears to reinitialize the variable on load.
                var ixTagAgain = (0, _getIndexExchangeTag.default)();

                _logger.default.debug("IndexExchange: bids requested"); // Fetch bid responses from Index Exchange.
                // Note: the current request is to a casalemedia URL.


                ixTagAgain.retrieveDemand(IXSlots, function (rawBidResponses) {
                  if (bidsReturned) {
                    // Ignore any responses except the first.
                    return;
                  }

                  bidsReturned = true;
                  ixRawBidResponses = rawBidResponses;
                  handleAuctionEnd(rawBidResponses);
                });
              }); // Resolve after some time to avoid waiting too long
              // for responses.

              timeoutId = setTimeout(function () {
                handleAuctionEnd();
              }, config.bidderTimeout);
            }));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchBids(_x) {
    return _ref.apply(this, arguments);
  };
}();

var setTargeting = function setTargeting() {
  // Set adserver targeting for any returned demand.
  // IX demand should set the IOM and ix_id parameters.
  try {
    if (ixRawBidResponses && ixRawBidResponses.slot) {
      var googletag = (0, _getGoogleTag.default)(); // Loop through defined GAM slots to set any targeting.

      googletag.cmd.push(function () {
        googletag.pubads().getSlots().forEach(function (googleSlot) {
          var IXSlotName = mapGAMSlotToIXSlot(googleSlot.getAdUnitPath());

          if (!IXSlotName) {
            // No Index Exchange unit for this Google slot.
            return;
          }

          var IXBidResponseArray = ixRawBidResponses.slot[IXSlotName];

          if (!IXBidResponseArray || !IXBidResponseArray.length) {
            // No Index Exchange bid for this ad unit.
            return;
          }

          IXBidResponseArray.forEach(function (IXBidResponse) {
            if (!IXBidResponse.targeting) {
              // No IX targeting provided.
              return;
            } // Set IX targeting on this slot.


            Object.keys(IXBidResponse.targeting).forEach(function (targetingKey) {
              // https://developers.google.com/doubleclick-gpt/reference#googletag.Slot_setTargeting
              googleSlot.setTargeting(targetingKey, IXBidResponse.targeting[targetingKey]);
            });
          });
        });
      });
    }
  } catch (e) {
    _logger.default.error(e);
  }

  _logger.default.debug("IndexExchange: set ad server targeting");
};

var IndexExchangeBidder = (0, _Bidder.default)({
  name: indexExchangeBidderName,
  fetchBids: fetchBids,
  setTargeting: setTargeting
});
var _default = IndexExchangeBidder;
exports.default = _default;